import axios from 'axios'
import { Notification } from 'element-ui'
import router from './../router'
import qs from 'qs';

// 创建axios实例
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';    
const service = axios.create({
  baseURL: '', // api 的 base_url
})

localStorage.setItem("sessionExpired", "false");

// request拦截器
service.interceptors.request.use(
  config => {
    let contentType = config.headers['Content-Type'] || config.headers.post['Content-Type'];
    if (config.method  === 'post' && contentType && contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
        config.data = qs.stringify(config.data);
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status
    const customCode = response.data.code
    if (code < 200 || code > 300) {
      Notification.error({
        title: '系统错误'
      })
      return Promise.reject('error')
    } else if (customCode === 401 && localStorage.getItem("sessionExpired") === "false") {
      localStorage.setItem("sessionExpired", "true");
      // if (response.config.url.indexOf('/user/company/info/find/') !== -1) {
      Notification.error({
        title: '会话已过期，请重新登录'
        })
      // }
      router.push('/login?redirect=' + router.history.current.fullPath)
      return Promise.reject(response.data)
    } 
    return response.data
  },
  error => {
    let code = 0
    try {
      code = error.response.data.code
      Notification.error({
        title: '系统异常',
        duration: 5000
      })
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: 'NETWORK TIMEOUT!',
          duration: 5000
        })
        return Promise.reject(error)
      }
    }
    if (!code)  {
       // TODO
    }
    return Promise.reject(error)
  }
)
export default service
